import { Smartphone } from "lucide-react";

interface RequestAppDisplayProps {
  bundleId?: string;
  appName: string;
  iconUrl?: string;
}

export const RequestAppDisplay = ({ bundleId, appName, iconUrl }: RequestAppDisplayProps) => {
  const displayName = appName || bundleId || 'Unknown app';
  const displayIcon = iconUrl;

  return (
    <div className="flex items-center gap-3">
      {displayIcon ? (
        <img 
          src={displayIcon} 
          alt={displayName}
          className="w-10 h-10 rounded-lg object-cover"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            e.currentTarget.nextElementSibling?.classList.remove('hidden');
          }}
        />
      ) : null}
      <div className={`w-10 h-10 rounded-lg bg-muted flex items-center justify-center ${displayIcon ? 'hidden' : ''}`}>
        <Smartphone className="w-5 h-5 text-muted-foreground" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-medium text-sm truncate">
          {displayName}
        </div>
        {bundleId && (
          <div className="text-xs text-muted-foreground truncate">
            {bundleId}
          </div>
        )}
      </div>
    </div>
  );
};
